import SurvayForm from "./SurvayForm";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeQuestion } from '@codex/pages/Survay/ducks/actions';
var mapStateToProps = function (state) {
    return {
    // page: state.survay.page
    };
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        changeQuestion: changeQuestion
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(SurvayForm);
// changeQuestion



//////////////////
// WEBPACK FOOTER
// ./src/components/SurvayForm/index.tsx
// module id = 1388
// module chunks = 0